import { render, staticRenderFns } from "./NewCoverYear.vue?vue&type=template&id=35f470b3"
import script from "./NewCoverYear.vue?vue&type=script&lang=js"
export * from "./NewCoverYear.vue?vue&type=script&lang=js"
import style0 from "./NewCoverYear.vue?vue&type=style&index=0&id=35f470b3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports